export const defaultFill = '#000000'
export const defaultOpacity = 1
